export default {
  computed: {
    parent(){
      return this.$parent?.$parent
    },
    headers(){
      if (this.parent) {
        return this.parent.headers
      } else return []
    },
    loading(){
      if (this.parent) {
        return this.parent.loading
      } else return true
    },
    no_data_text(){
      if (this.parent) {
        return this.parent.no_data_text
      } else return ''
    },
    search() {
      if (this.parent) {
        return this.parent.search
      } else return ''
    },
    draggable() {
      if (this.parent) {
        return this.parent.search
      } else return ''
    }
  }
}